/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import languageContext, { LanguageContext } from './languageContext';

export const useLanguages = (): LanguageContext =>
  React.useContext<LanguageContext>(languageContext);
